var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThreeDotMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 9.16602C9.77866 9.16602 9.5667 9.25381 9.41042 9.41009C9.25414 9.56637 9.16634 9.77834 9.16634 9.99935C9.16634 10.2204 9.25414 10.4323 9.41042 10.5886C9.5667 10.7449 9.77866 10.8327 9.99967 10.8327C10.2207 10.8327 10.4326 10.7449 10.5889 10.5886C10.7452 10.4323 10.833 10.2204 10.833 9.99935C10.833 9.77834 10.7452 9.56637 10.5889 9.41009C10.4326 9.25381 10.2207 9.16602 9.99967 9.16602Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 9.16797C3.94565 9.16797 3.73369 9.25577 3.57741 9.41205C3.42113 9.56833 3.33333 9.78029 3.33333 10.0013C3.33333 10.2223 3.42113 10.4343 3.57741 10.5906C3.73369 10.7468 3.94565 10.8346 4.16667 10.8346C4.38768 10.8346 4.59964 10.7468 4.75592 10.5906C4.9122 10.4343 5 10.2223 5 10.0013C5 9.78029 4.9122 9.56833 4.75592 9.41205C4.59964 9.25577 4.38768 9.16797 4.16667 9.16797Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8337 9.16602C15.6126 9.16602 15.4007 9.25381 15.2444 9.41009C15.0881 9.56637 15.0003 9.77834 15.0003 9.99935C15.0003 10.2204 15.0881 10.4323 15.2444 10.5886C15.4007 10.7449 15.6126 10.8327 15.8337 10.8327C16.0547 10.8327 16.2666 10.7449 16.4229 10.5886C16.5792 10.4323 16.667 10.2204 16.667 9.99935C16.667 9.77834 16.5792 9.56637 16.4229 9.41009C16.2666 9.25381 16.0547 9.16602 15.8337 9.16602Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotMenu);
export default __webpack_public_path__ + "static/media/three-dot-menu.ad9b79fa74cc2e846e9cf2a2512cb0a7.svg";
export { ForwardRef as ReactComponent };